import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';

// The API does not issue chat tokens while impersonating (messages would be sent as the impersonated user),
// so the chat must not mount at all - otherwise the TalkJS session would request a token and fail
const ChatImpersonationGuard = ({ children }) => {
  const impersonatedUser = useSelector((state) => state.app.impersonating);

  if (impersonatedUser) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
        Chat is not available while impersonating a user.
      </Typography>
    );
  }

  return children;
};

export const withChatImpersonationGuard = (Component) => (props) =>
  (
    <ChatImpersonationGuard>
      <Component {...props} />
    </ChatImpersonationGuard>
  );

export default ChatImpersonationGuard;
